<template>
  <v-layout>
    <v-dialog v-model="showDialogItem" persistent max-width="600">
      <v-card>
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{titleComponent}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" flat color="error" icon round @click.native="cancelNewItem()">
              <v-icon large color="error">clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

          <v-layout justify-space-between row wrap px-3 pt-4>
            <v-flex xs12 py-0>
              <v-autocomplete :items="consumables" box item-text="description" item-value="description" v-model="consumable"
                label="Descrição / Especificação" return-object></v-autocomplete>
            </v-flex>
            <v-flex xs12 py-0>
              <v-text-field box v-model="consumable.unity" label="Unidade" title="Unidade" disabled></v-text-field>
            </v-flex>
            <v-flex xs12 py-0>
              <v-text-field v-model="consumable.quantity" label="Quantidade" box></v-text-field>
            </v-flex>
            <!-- <v-flex xs12  py-0>
                <v-text-field box v-model="consumable.lifetime" :label="labelDepreciation"></v-text-field>
              </v-flex> -->
            <v-flex xs12 py-0>
              <v-text-field v-model.lazy="consumable.value" label="Valor Unitário (R$)" box></v-text-field>
            </v-flex>
            <!-- <v-flex xs12  offset-md10 py-0>
                <v-btn color="success lighten-1"  large @click.stop.prevent="save();" block>Salvar</v-btn>
              </v-flex> -->
          </v-layout>
        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1" @click.native="save();">
            Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import ProductService from "../../../service/ProductService.js";
  export default {

    data() {
      return {
        loading: false,
        showDialogItem: false,
        consumable: {},
        consumables: [],
        edit:false
      }
    },
    methods: {
      addNewItem() {
        this.initialize()
        this.showDialogItem = true
      },
      editItem(item) {
        this.loadDescriptions()
        this.edit = true
        this.consumable = item;
        
        this.showDialogItem = true
      },
      cancelNewItem() {
        this.consumable = {};
        this.consumables = [];
        this.edit = false;
        this.showDialogItem = false;
      },
      async loadDescriptions() {
        this.consumables = await ProductService.getByCategory({
          type: "Material de Consumo"
        })
      },
      save() {
        this.$emit('addConsumable', this.consumable)
        this.showDialogItem = false;
      },
      async initialize() {
        this.loading = true;
        this.loadDescriptions()
        try {
          this.consumable = Object.assign({});
          this.edit = false
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
        }
      },
    },
    computed:{
      titleComponent(){
        return this.edit ? "Editar Item" : "Novo Item"
      }
    }
  }

</script>
S



// WEBPACK FOOTER //
// src/components/contract/dialogs/DialogConsumables.vue